import ApplicationAdapter from 'lumen/adapters/application';

export default class BudgetForecastCapacityAdapter extends ApplicationAdapter {
  pathForType(): string {
    return 'budgetforecast/capacity';
  }
}
